var map = {
	"./atharva.jpg": 9415,
	"./aviraj.jpg": 7215,
	"./ayushi.jpg": 5993,
	"./chetana.jpg": 9607,
	"./harshd.jpg": 4318,
	"./harshw.jpg": 3241,
	"./himanshu.jpg": 7089,
	"./isha.jpg": 8799,
	"./mayank.jpg": 1479,
	"./megha.jpg": 3780,
	"./mihir.jpg": 959,
	"./navneet.jpg": 923,
	"./parnika.jpg": 4566,
	"./prof_kulkarni.jpg": 7321,
	"./prof_talele.jpg": 5749,
	"./shrutika.jpg": 2921,
	"./siddhant.jpg": 5957,
	"./soham.jpg": 9072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9087;